/* eslint-disable react/no-multi-comp */
import SuccessStatus from '~/icons/greenEllipsis.svg?react';
import AlertsMuted from '~/icons/notificationSilenced.svg?react';
import Warning from '~/icons/warning.svg?react';
import CautionStatus from '~/icons/yellowEllipsis.svg?react';

export const WarningIcon = () => (
  <Warning
    style={{
      width: 22,
      // @ts-expect-error backgroundColor isn't typed correctly
      backgroundColor: 'transparent',
    }}
  />
);

export const AlertsMutedIcon = () => (
  <AlertsMuted
    style={{
      width: 22,
      // @ts-expect-error backgroundColor isn't typed correctly
      backgroundColor: 'transparent',
    }}
  />
);

export const SuccessIcon = () => (
  <SuccessStatus
    style={{
      width: 18,
      height: 18,
      // @ts-expect-error backgroundColor isn't typed correctly
      backgroundColor: 'transparent',
    }}
  />
);

export const CautionIcon = () => (
  <CautionStatus
    style={{
      width: 18,
      height: 18,
      // @ts-expect-error backgroundColor isn't typed correctly
      backgroundColor: 'transparent',
    }}
  />
);
